import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Define the structure for the selected client
interface Client {
  phoneNumber: string;
  id: string;
  clientId?: string;
  userId?: string;
  roleId?: number;
  name: string;
  email?: string;
  phone?: string;
  status?: string;
  latestItem?: string;
  clientSince?: string;
  createdAt?: string;
  createdOn?: string;
  createdDate?: string;
}

interface SelectedClientState {
  selectedClient: Client | null;
}

// Load initial state from localStorage
const loadInitialState = (): SelectedClientState => {
  const storedClient = localStorage.getItem("client");
  if (storedClient) {
    return { selectedClient: JSON.parse(storedClient) as Client };
  }
  return { selectedClient: null };
};

// Initial state
const initialState: SelectedClientState = loadInitialState();

const selectedClientSlice = createSlice({
  name: "selectedClient",
  initialState,
  reducers: {
    setSelectedClient(state, action: PayloadAction<Client>) {
      state.selectedClient = action.payload;

      // Store in localStorage
      localStorage.setItem("client", JSON.stringify(action.payload));
    },
    deleteSelectedClient(state) {
      state.selectedClient = null;

      // Remove from localStorage
      localStorage.removeItem("client");
    },
  },
});

// Export actions and reducer
export const { setSelectedClient, deleteSelectedClient } =
  selectedClientSlice.actions;

export default selectedClientSlice.reducer;
